import { Reveal } from "./Reveal";
import { EXPERIENCE_ORGS } from "../data/content";

const Diamond = () => (
  <svg viewBox="0 0 8 8" className="h-2 w-2 shrink-0 text-primary" fill="currentColor" aria-hidden="true">
    <rect x="1.5" y="1.5" width="5" height="5" transform="rotate(45 4 4)" />
  </svg>
);

export const Experience = () => {
  const items = [
    "5–15+ years of engineering experience",
    ...EXPERIENCE_ORGS,
    "Production-grade systems",
    "Enterprise architecture",
  ];
  const row = [...items, ...items, ...items];

  return (
    <section id="experience" className="relative border-y hairline bg-card/40" data-testid="experience-section">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <Reveal className="max-w-xl">
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-primary font-semibold">02 / Experience</p>
            <h2 className="mt-3 font-display text-2xl sm:text-3xl font-extrabold tracking-tight">
              Senior engineering. <span className="text-primary">Enterprise mindset.</span>
            </h2>
            <p className="mt-3 text-sm sm:text-base text-muted-foreground leading-relaxed">
              Farmint brings together experienced software engineers with 5–15+ years of
              experience building and operating production-grade software systems — including
              engineering backgrounds at organizations such as:
            </p>
          </Reveal>
          <Reveal delay={0.15} className="flex flex-wrap gap-3">
            {EXPERIENCE_ORGS.map((org) => (
              <span
                key={org}
                data-testid={`org-chip-${org.toLowerCase()}`}
                className="rounded-full border hairline bg-background/60 px-5 py-2 font-display text-sm font-bold tracking-wide text-foreground/85"
              >
                {org}
              </span>
            ))}
          </Reveal>
        </div>
      </div>
      <div className="relative overflow-hidden border-t hairline py-4" data-testid="experience-marquee">
        <div className="animate-marquee flex w-max items-center gap-8 pr-8">
          {row.map((item, i) => (
            <span key={i} className="flex items-center gap-8 whitespace-nowrap font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
              {item}
              <Diamond />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
